import { render, staticRenderFns } from "./document-control-container.vue?vue&type=template&id=719393c3&"
import script from "./document-control-container.vue?vue&type=script&lang=js&"
export * from "./document-control-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports